import { roleMap } from '@/api';
import { get } from '@/common/request';

interface RoleListResponce {
  totalNum?: number;
  pageNum?:	number;
  pageSize?: number;
  objectList?: [];
  meta?: any;
}

class RoleStore {
  getRoleSearch (keyword: string): Promise<RoleListResponce[]> {
    return get(roleMap.get('search'), { keyword }, { proxyApi: '/mirage', needHint: true });
  }
}

export default new RoleStore();
